// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"f2bbaf9b","308":"574a7188","453":"03346f77","530":"a57dc774","571":"e99d50e2","645":"fab1be6f","660":"0b093645","886":"ee69a474","963":"ac6044ad"}[chunkId] + ".chunk.js";
};